import {
  faClipboardList,
  faCommentDots,
  faHeadphones,
  faMicrophone,
  faBookOpen,
  faInfoCircle
} from "@duocards/pro-solid-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-common-types";
import type { AssistantMode } from "components/assistant/__generated__/AssistantMutation.graphql";

export type PracticeOption = {
  title: string;
  description: string;
  icon: IconDefinition;
  mode: AssistantMode;
};

export const practiceOptions: PracticeOption[] = [
  {
    title: "ask",
    description: "Ask tutor about anything.",
    icon: faCommentDots,
    mode: "assistant"
  },
  {
    title: "speak",
    description: "Practice speaking without fear.",
    icon: faMicrophone,
    mode: "speaking"
  },
  {
    title: "listen",
    description: "Hear your cards on repeat.",
    icon: faHeadphones,
    mode: "listenVocab"
  },
  {
    title: "test",
    description: "Fill in the blanks.",
    icon: faClipboardList,
    mode: "letsPractise"
  },
  {
    title: "story",
    description: "",
    icon: faBookOpen,
    mode: "aiStory"
  },
  {
    title: "info",
    description: "",
    icon: faInfoCircle,
    mode: "cardDetail"
  }
];

export const getPracticeOptionByMode = (mode: AssistantMode): PracticeOption | undefined => {
  return practiceOptions.find((o) => o.mode === mode);
};
